import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import CustomSelect from "src/generator/_Selects/CustomSelect/CustomSelect";
import CustomInput from "src/generator/CustomInput/CustomInput";
import { FGAS_TAGS, getRefrigerantOptions } from "src/generator/utils/fgas";
import { findColIdByTag } from "src/generator/utils/rowTags";
import { useSelector } from "src/redux/hooks";

interface Props {
  id: string;
  value: any;
  required: boolean;
  cols?: Record<string, any>;
}

const FgasRefrigerantInput = ({ id, value, required, cols }: Props) => {
  const gwp = useSelector(state => state.generatorSlice.gwp);
  const { setValue } = useFormContext();

  const data = useMemo(
    () =>
      getRefrigerantOptions(
        gwp,
        typeof value === "object" ? value?.key : value,
      ),
    [gwp, value],
  );

  const handleSelect = useCallback(
    (selected: string) => {
      const item = gwp.find(
        el => el.active === 1 && el.refrigerant?.trim() === selected,
      );
      if (!item) return;

      const otherNameId = findColIdByTag(cols, FGAS_TAGS.otherName, id);
      const gwpId = findColIdByTag(cols, FGAS_TAGS.gwp, id);
      if (otherNameId) setValue(otherNameId, item.other_name);
      if (gwpId) setValue(gwpId, item.gwp);
    },
    [cols, gwp, id, setValue],
  );

  if (gwp.length > 0) {
    return (
      <CustomSelect
        data={data}
        id={id}
        value={value}
        required={required}
        onChange={handleSelect}
      />
    );
  }

  return <CustomInput id={id} value={value} required={required} />;
};

export default FgasRefrigerantInput;
